export const loadState = () =>{
//	console.log("> loadState <");
	try{
		const serializedState = localStorage.getItem('state');
		if(serializedState===null){
			//return undefined;
			return  {
				newProject: [{id:0, comment:"", reference:"", doc:{}, attachment:{}, task:[], urgent:false, special:false, quotation:false}],
				search: "",
				xliff: "",
				processingOrders: false
			}
		}
		return JSON.parse(serializedState);
	}catch(err){
		return undefined;
	}
};

export const saveState = (state) => {
//	console.log("> saveState <");
	try{
		const serializedSatate = JSON.stringify(state);
		localStorage.setItem('state', serializedSatate);
	}catch(err){
		//
	}
};